import type { FC } from 'react'
import { useGlobalCommandHotkeys } from './global-command-hotkeys.js'

/**
 * Self-mounting wrapper that runs `useGlobalCommandHotkeys` inside the
 * provider tree. Renders nothing; exists so the hook can sit below
 * `GlobalAppContext.Provider` + `DIContainer` (which the hook's
 * `useUserConfig` / `useGlobalCommands` calls depend on) without
 * polluting any visible layout.
 */
export const GlobalCommandHotkeys: FC = () => {
  useGlobalCommandHotkeys()
  return null
}
